import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { catchError, filter, of, switchMap, map, Observable } from 'rxjs';

import { ConfirmationModalService } from '@tablesready/common-ui';
import { AlertsService } from '@tablesready/frontend-alerts-bar';
import { UserApiService } from '@tablesready/frontend-auth';
import { LoginService } from './login.service';

@Injectable()
export class LinkAccountsService {
  constructor(
    private readonly router: Router,
    private readonly alertsService: AlertsService,
    private readonly confirmationModalService: ConfirmationModalService,
    private readonly userApiService: UserApiService,
    private readonly loginService: LoginService,
  ) {}

  linkAccount(email: string, token: string): Observable<any> {
    return this.confirmationModalService.confirm({
      title: 'User already exists',
      content: `User with email ${email} already exists. Would you like to link it with Google?`,
      confirmBtnText: 'Link with Google',
    })
      .pipe(
        filter(({ isConfirmed }) => isConfirmed),
        switchMap(() => this.userApiService.linkWithGoogle(token)),
        switchMap(() => this.loginService.loginByGoogle({ token })),
        map(result => this.loginService.setNavigatePath(result)),
        map((navigatePath: string) => {
          void this.router.navigateByUrl(navigatePath);

          return null;
        }),
        catchError(error => {
          this.alertsService.addError(error, 'Error signing in: ');

          return of(null);
        }),
      );
  }
}
